import React from "react";
import styled from "styled-components/macro";
import { Button, Switch } from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

const UploadFileChooseProperties = ({
	color,
	setColor,
	duplex,
	setDuplex,
	copies,
	setCopies,
	file,
	printer,
	onStartPrintPress,
}) => {
	return (
		<Wrapper>
			<Title>Choose properties</Title>
			<ParamWrapper>
				<ParamTitle checked={color}>Color</ParamTitle>
				<IOSSwitch
					checked={color}
					onChange={(value) => {
						setColor(value.target.checked);
					}}
					name="checkedB"
				/>
			</ParamWrapper>

			<ParamWrapper>
				<ParamTitle checked={duplex}>Duplex</ParamTitle>
				<IOSSwitch
					checked={duplex}
					onChange={(value) => {
						setDuplex(value.target.checked);
					}}
					name="checkedB"
				/>
			</ParamWrapper>
			<ParamWrapper>
				<ParamTitle checked>Copies</ParamTitle>
				<div className="custom-select" style={{ width: "200px" }}>
					<select
						onChange={(event) => setCopies(event.target.value)}
						className="card-text"
					>
						<option>1</option>
						<option>2</option>
						<option>3</option>
						<option>4</option>
						<option>5</option>
						<option>6</option>
						<option>7</option>
						<option>8</option>
						<option>9</option>
					</select>
				</div>
			</ParamWrapper>
			<FileName
				style={{ marginBottom: 0, paddingBottom: 0 }}
			>{`File name: ${file.name}`}</FileName>
			<FileName>{`Printer: ${printer.room_name}`}</FileName>
			<ButtonWrapper>
				<ColorButton
					variant="contained"
					color="primary"
					onClick={() => {
						onStartPrintPress({ color, printer, duplex, copies });
					}}
				>
					Print file
				</ColorButton>
			</ButtonWrapper>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	border-radius: 8px;
	background-color: white;
	border: none;
`;

const ButtonWrapper = styled.div`
	justify-content: center;
	display: flex;
	position: relative;
	margin: 15px 0 25px;
`;

const Title = styled.div`
	font-size: 20px;
	color: #222;
	padding: 10px;
`;

const ParamTitle = styled.div`
	font-size: 16px;
	color: ${({ checked }) => (checked ? "#2b2b2b" : "#9a9a9a")};
	padding: 10px;
	flex: 1;
`;

const ParamWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 10px;
`;

const FileName = styled.div`
	margin: 0 12px;
	font-size: 14px;
	color: #4a4a4a;
	padding: 10px;
`;
export { UploadFileChooseProperties };

export const IOSSwitch = withStyles((theme) => ({
	root: {
		width: 42,
		height: 26,
		padding: 0,
		margin: theme.spacing(1),
	},
	switchBase: {
		padding: 1,
		"&$checked": {
			transform: "translateX(16px)",
			color: theme.palette.common.white,
			"& + $track": {
				backgroundColor: "#2D5566",
				opacity: 1,
				border: "none",
			},
		},
		"&$focusVisible $thumb": {
			color: "#2D5566",
			border: "6px solid #fff",
		},
	},
	thumb: {
		width: 24,
		height: 24,
	},
	track: {
		borderRadius: 26 / 2,
		border: `1px solid ${theme.palette.grey[400]}`,
		backgroundColor: theme.palette.grey[50],
		opacity: 1,
		transition: theme.transitions.create(["background-color", "border"]),
	},
	checked: {},
	focusVisible: {},
}))(({ classes, ...props }) => {
	return (
		<Switch
			focusVisibleClassName={classes.focusVisible}
			disableRipple
			classes={{
				root: classes.root,
				switchBase: classes.switchBase,
				thumb: classes.thumb,
				track: classes.track,
				checked: classes.checked,
			}}
			{...props}
		/>
	);
});

const ColorButton = withStyles((theme) => ({
	root: {
		color: "white",
		backgroundColor: "#2D5566",
		"&:hover": {
			backgroundColor: "#2D5566",
		},
	},
}))(Button);
